export class ResponseError {
    mensaje: string = "";
}
